export default "__VITE_ASSET__CcL013$3__"